// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"85eeaf6b","453":"54467cb5"}[chunkId] + ".chunk.js";
};